import { render, staticRenderFns } from "./IconSmallPodbeanLogo.vue?vue&type=template&id=3bade198&"
import script from "./IconSmallPodbeanLogo.vue?vue&type=script&lang=js&"
export * from "./IconSmallPodbeanLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports